import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@lanl-web/lanl-components';
import FilterIcon from '../../assets/svg/filter.inline.svg';
import SearchIcon from '../../assets/svg/search.inline.svg';
import ExitIcon from '../../assets/svg/exit.inline.svg';

import './Filter.scss';

export const Filter = ({
  filterPageSections,
  pageSectionGroups,
  setFilteredSectionGroups,
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [allFilterTags, setAllFilterTags] = useState([]);
  const [filtersSelected, setFiltersSelected] = useState([]);

  useEffect(() => {
    let uniqueTags = new Set();

    pageSectionGroups?.forEach(({ rl_page_sections }) => {
      rl_page_sections?.forEach(({ tags }) => {
        tags?.forEach((tag) => {
          tag.toUpperCase() !== 'NONE' && uniqueTags.add(tag.toUpperCase());
        });
      });
    });

    setAllFilterTags(Array.from(uniqueTags).sort());
    setFilteredSectionGroups(pageSectionGroups);
  }, []);

  useEffect(() => {
    filterPageSections(filtersSelected.length ? filtersSelected : []);
  }, [filtersSelected]);

  const toggleFiltersComponent = () => {
    setFiltersOpen(!filtersOpen);
  };

  const toggleDropdownSelection = (e) => {
    const selection = e.target.name;
    const checked = e.target.checked;

    if (selection === 'SELECT ALL') {
      setFiltersSelected(checked ? allFilterTags : []);
      return;
    }

    if (checked) {
      addTag(selection);
    } else {
      removeTag(selection);
    }
  };

  const handleFilterSearch = (e) => {
    const input = e.target.value.toUpperCase();
    const filters = document.getElementsByClassName('selection');

    Array.from(filters).forEach((filter) => {
      if (filter.getAttribute('name').indexOf(input) > -1) {
        filter.style.display = '';
      } else {
        filter.style.display = 'none';
      }
    });
  };

  const addTag = (name) => {
    setFiltersSelected([...filtersSelected, name].sort());
  };

  const removeTag = (name) => {
    const updatedTags = filtersSelected.filter((tag) => tag !== name);

    if (filtersOpen) {
      document.querySelector('input[name="SELECT ALL"]').checked = false;
    }

    setFiltersSelected(updatedTags);
  };
  return (
    <div className='filter'>
      <div className='tags-and-dropdown-container'>
        <div className='filter-dropdown' onClick={toggleFiltersComponent}>
          <FilterIcon className='filter-icon' />
          <span className='label'>FILTERS</span>
          <Icon
            className='chevron'
            icon={filtersOpen ? 'chevron-up' : 'chevron-down'}
            size='xs'
          />
        </div>

        <div className='section-tags-container'>
          {filtersSelected &&
            filtersSelected.map((tag) => {
              return (
                <div
                  className='section-tags'
                  onClick={(e) => removeTag(e.currentTarget.innerText)}
                  key={tag}
                >
                  <ExitIcon className='exit-icon' />
                  {tag}
                </div>
              );
            })}
        </div>
      </div>

      {filtersOpen && (
        <div className='filter-search'>
          <div className='search-bar'>
            <SearchIcon className='search-icon' />
            <input
              className='search-input'
              type='input'
              name='search-bar'
              placeholder='Search'
              autoComplete='off'
              onChange={handleFilterSearch}
            />
          </div>

          <div className='search-bar-dropdown'>
            <div className='dropdown-list'>
              <div
                className='selection'
                name='SELECT ALL'
                key={`selection-select-all`}
              >
                <input
                  className='checkbox-input'
                  name='SELECT ALL'
                  type='checkbox'
                  onChange={toggleDropdownSelection}
                />
                <span className='label'>SELECT ALL</span>
              </div>
              {allFilterTags &&
                allFilterTags.map((tag) => {
                  const isChecked = filtersSelected.includes(tag);
                  return (
                    <div
                      className='selection'
                      name={tag}
                      key={`selection-${tag}`}
                    >
                      <input
                        className='checkbox-input'
                        name={tag}
                        type='checkbox'
                        onChange={toggleDropdownSelection}
                        checked={isChecked}
                      />
                      <span className='label'>{tag}</span>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Filter.propTypes = {
  filterPageSections: PropTypes.func.isRequired,
  pageSectionGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFilteredSectionGroups: PropTypes.func.isRequired,
};

export default Filter;
